module.exports = __webpack_public_path__ + "static/img/logo-DBG.a2257c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/logo-DBG.png
// module id = DYY8
// module chunks = 1